

/// <reference path="AccountBalance.ts" />

// Generated class ClientDebtBalance_ManagedObject

class ClientDebtBalance_ManagedObject extends AccountBalance
{
}
